angular.module('tgaApp').service('cssAnimationService', function () {
  this.attachCSSAnimation = function (settings) {
    const revert = settings.revert || false;
    settings.element.addClass(settings.animation);
    settings.element
      .css('-webkit-animation-duration', settings.duration)
      .css('-moz-animation-duration', settings.duration)
      .css('animation-duration', settings.duration);
    settings.element.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
      if (revert) {
        settings.element.removeClass(settings.animation);
      }
      if (settings.after) {
        settings.after();
      }
      settings.element.off('webkitAnimationEnd oanimationend msAnimationEnd animationend');
    });
  };
});
